import React, { Component } from 'react'
import css from './style.css'
import ToggleDisplay from '../toggle-display'
import Button from '../button'
import Price from '../price'
import Spacer from '../spacer'
import PlusIcon from 'react-icons/lib/fa/plus-square'
import MinusIcon from 'react-icons/lib/fa/minus-square'

class JewelryPriceBreakdown extends Component {
  constructor (props) {
    super(props)
    this.state = {
      breakdownVisible: false
    }
    this.toggleBreakdownDisplay = this.toggleBreakdownDisplay.bind(this)
  }

  toggleBreakdownDisplay () {
    if (this.state.breakdownVisible) {
      this.setState({breakdownVisible: false})
    } else {
      this.setState({breakdownVisible: true})
    }
  }

  render () {
    const displayIcon = () => {
      if (this.state.breakdownVisible) {
        return <i><MinusIcon /></i>
      } else {
        return <i><PlusIcon /></i>
      }
    }

    const renderPriceField = (title, fieldName) => {
      return (
        <div>
          <div className={css.priceHeading}>{title}</div>
          <div className={css.price}>
            <Price price={getPriceField(fieldName)} styleClass={css.price} />
          </div>
        </div>
      )
    }

    const getPriceField = (fieldName) => {
      if (!this.props.result) return 0
      return this.props.result[fieldName] ? this.props.result[fieldName] : 0
    }

    return (
      <div>
        <Spacer md />
        <ToggleDisplay show={this.props.priceVisible}>
          <Button buttonId={'price_breakdown_btn'} onClick={this.toggleBreakdownDisplay}>
            {displayIcon()} Price Breakdown
          </Button>
          <Spacer xs />
          <ToggleDisplay show={this.state.breakdownVisible}>
            <h3>Note: ALL AMOUNTS IN USD</h3>
            {renderPriceField('Additional Charge', 'additional_price_in_usd')}
            {renderPriceField('Design Charge', 'design_price')}
            {renderPriceField('Metal Cost', 'metal_cost')}
            {renderPriceField('Multi Stone Diamond Cost', 'multi_stone_diamond_cost')}
            {renderPriceField('Multi Stone Setting Cost', 'multi_stone_setting_cost')}
            {renderPriceField('Centre Halo Diamond Cost', 'central_halo_diamond_cost')}
            {renderPriceField('Centre Halo Setting Cost', 'central_halo_setting_cost')}
            {renderPriceField('SideStone Halo Diamond Cost', 'side_stone_halo_diamond_cost')}
            {renderPriceField('SideStone Halo Setting Cost', 'side_stone_halo_setting_cost')}
            {renderPriceField('Side of Halo Diamond Cost', 'side_of_halo_diamond_cost')}
            {renderPriceField('Side of Halo Setting Cost', 'side_of_halo_setting_cost')}
            {renderPriceField('Shank Diamond Cost', 'shank_diamond_cost')}
            {renderPriceField('Shank Setting Cost', 'shank_setting_cost')}
            {renderPriceField('Outside Shank Diamond Cost', 'outside_shank_diamond_cost')}
            {renderPriceField('Outside Shank Setting Cost', 'outside_shank_setting_cost')}
            {renderPriceField('Bail Diamond Cost', 'bail_diamond_cost')}
            {renderPriceField('Bail Diamond Setting Cost', 'bail_diamond_setting_cost')}
            {renderPriceField('Additional Diamond(s) Cost', 'additional_diamond_stone_cost')}
            {renderPriceField('Additional Diamond(s) Setting Cost', 'additional_diamond_setting_cost')}
            {renderPriceField('Polishing Cost', 'polishing_cost')}
            {renderPriceField('Milgrain Centre Halo Cost', 'milgrain_centre_halo_cost')}
            {renderPriceField('Milgrain SideStone Halo Cost', 'milgrain_side_stone_halo_cost')}
            {renderPriceField('Milgrain Side of Halo Cost', 'milgrain_side_of_halo_cost')}
            {renderPriceField('Milgrain Shank Top Cost', 'milgrain_shank_top_cost')}
            {renderPriceField('Milgrain Shank Sides Cost', 'milgrain_shank_side_cost')}
            {renderPriceField('Milgrain Bail Cost', 'milgrain_bail_cost')}
            {renderPriceField('Additional Milgrain Cost', 'additional_milgrain_cost')}
            {renderPriceField('Hand Engraving Cost', 'hand_engraving_cost')}
            {renderPriceField('Special finish Charge', 'special_finish_charge')}
            {renderPriceField('Pendant Chain Cost', 'pendant_chain_cost')}
            {renderPriceField('Setting of Centre Stone', 'setting_of_centre_stone')}
            {renderPriceField('Total (USD)', 'cost_price_in_usd')}
            {renderPriceField('Total (CAD)', 'cost_price_in_cad')}
            {renderPriceField('Base Price (USD)', 'base_price_in_usd')}
            {renderPriceField('Base Price (CAD)', 'base_price_in_cad')}
            {renderPriceField('Sale Price (USD)', 'sale_price_in_usd')}
            {renderPriceField('Sale Price (CAD)', 'sale_price_in_cad')}
          </ToggleDisplay>
        </ToggleDisplay>
      </div>
    )
  }
}

export default JewelryPriceBreakdown



// WEBPACK FOOTER //
// ./src/components/jewelry-price-breakdown/index.js